/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { sendPushNotification } from '../../../api/users.api';

export default function UserOptionsCardPushNotification({ user, closeModal }) {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  const targetUser = user?.user;
  const username = targetUser?.username || '';
  const displayName = `${targetUser?.firstName || ''} ${targetUser?.lastName || ''}`.trim() || username || 'User';

  const handleSendPushNotification = async () => {
    if (!title.trim() || !message.trim()) {
      toast.error('Title and message body are required for Push Notification');
      return;
    }

    setLoading(true);

    const payload = {
      title: title.trim(),
      body: message.trim(),
      username,
    };

    const result = await sendPushNotification(payload);

    if (result.ok && result.data?.success !== false) {
      toast.success(`Push notification sent successfully to @${username || 'user'}`);
      setTitle('');
      setMessage('');
      closeModal();
    } else {
      toast.error(result.data?.message || 'Failed to send push notification');
    }

    setLoading(false);
  };

  return (
    <Box sx={{ p: 1 }}>
      <Typography variant="h6" sx={{ fontWeight: 800, mb: 0.5, color: '#111827' }}>
        Send Push Notification
      </Typography>
      <Typography variant="body2" sx={{ color: '#6B7280', mb: 2.5 }}>
        Sends a real-time push notification directly to <strong>{displayName}</strong> (@{username})&apos;s mobile device.
      </Typography>

      <Stack spacing={2}>
        <TextField
          fullWidth
          label="Target User"
          disabled
          value={`@${username} (${displayName})`}
          size="small"
        />

        <TextField
          fullWidth
          label="Notification Title"
          placeholder="e.g. Account Alert or Special Promotion"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          size="small"
        />

        <TextField
          fullWidth
          label="Message Body"
          placeholder="Type push notification content here..."
          multiline
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Stack>

      <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Button variant="outlined" color="inherit" onClick={closeModal} disabled={loading}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          loading={loading}
          onClick={handleSendPushNotification}
          disabled={!title.trim() || !message.trim()}
          sx={{ bgcolor: '#111827', '&:hover': { bgcolor: '#1F2937' } }}
        >
          Send Push Notification
        </LoadingButton>
      </Stack>
    </Box>
  );
}

UserOptionsCardPushNotification.propTypes = {
  user: PropTypes.object,
  closeModal: PropTypes.func,
};
